import { Controller } from "@hotwired/stimulus"

// Controls select all/deselect all and search functionality for the leave request filter dialog
export default class extends Controller {
  static targets = ["statusCheckbox", "employeeCheckbox", "employeeItem"]

  selectAllStatuses(event) {
    event.preventDefault()
    this.statusCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  deselectAllStatuses(event) {
    event.preventDefault()
    this.statusCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }

  selectAllEmployees(event) {
    event.preventDefault()
    this.employeeCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  deselectAllEmployees(event) {
    event.preventDefault()
    this.employeeCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
  }

  searchEmployees(event) {
    const query = event.target.value.toLowerCase().trim()
    this.employeeItemTargets.forEach((item) => {
      const name = item.dataset.name.toLowerCase()
      item.classList.toggle("hidden", query && !name.includes(query))
    })
  }
}
